import React, { useEffect, useState } from 'react'
import './styles.scss'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { Loader } from 'react-bootstrap-typeahead'

interface IPROPS {
  totalRecords: any
  columns: any
}

const TableNavigation: React.FC<IPROPS> = ({ totalRecords, columns }) => {
  const [loading, setLoading] = useState<boolean>(false)
  const [loadingForecast, setLoadingForecast] = useState<boolean>(false)
  const [checkStatus, setCheckStatus] = useState<boolean>(false)
  const navigate = useNavigate()

  const navigateHandler = () => {
    navigate('/excel')
  }

  const navigateForecastHandler = () => {
    setLoadingForecast(true)
    setTimeout(() => {
      setLoadingForecast(false)
      navigate('/excel_table/forecast')
    }, 5000)
  }
  useEffect(() => {
    checkStatusApi()
  }, [])

  const checkStatusApi = async () => {
    // setLoading(true)
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_CSV_ANALYTICS_URL}/csv-analytics/status`
      )
      setCheckStatus(response.data.upload_in_progress)
    } catch (error) {
      console.log(error, 'error')
      setLoading(false)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <div className='table_header'>
        <div
          style={{
            display: 'flex',
            width: '13%',
            borderRight: '1px solid hsl(240, 17.4%, 91%)',
            justifyContent: 'space-between',
            padding: '5px'
            // alignItems:"center"
          }}
        >
          <div style={{ height: '40px', display: 'flex', alignItems: 'center' }}>
            <i className='bi bi-journal-text' style={{ color: 'blue', fontSize: '25px' }}></i>
          </div>
          <div>
            <p style={{ display: 'flex', flexDirection: 'column' }}>
              <span style={{ color: 'hsl(240, 46.3%, 8%)', fontSize: '14px' }}>Data.csv</span>
              <span style={{ fontSize: '12px', color: 'hsl(240, 10.3%, 38%)' }}>
                {totalRecords} rows, {columns?.length - 2}columns
              </span>
            </p>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', fontSize: '0px' }}>
            <span>
              <i className='bi bi-chevron-up'></i>
            </span>
            <span>
              <i className='bi bi-chevron-down'></i>
            </span>
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            flex: '1',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '0 20px'
          }}
        >
          <p style={{ color: 'hsl(217.8, 15.1%, 64.9%)' }}>No Transforms Applied</p>
          <p
            style={{
              color: 'hsl(220.6, 13.2%, 46.1%)',
              display: 'flex',
              alignItems: 'center',
              gap: '20px'
            }}
          >
            <span>
              <i className='bi bi-pencil-square'></i>
            </span>
            <span>Auto generated Dashboard</span>
          </p>
        </div>
      </div>
      <div className='table_nav'>
        <div className='left'>
          <p
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '5px 10px',
              border: '1px solid blue',
              borderRadius: '6px',
              gap: '10px'
            }}
          >
            <span>
              <i className='bi bi-asterisk'></i>
            </span>
            <span style={{ fontSize: '14px', fontWeight: '500' }}> Chat Data Prep </span>
          </p>
          <p
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              color: 'hsl(220.6, 13.2%, 46.1%)',
              fontSize: '14px'
            }}
          >
            <span>
              <i className='bi bi-stars'></i>
            </span>
            <span>Clean</span>
          </p>
          <p
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              color: 'hsl(220.6, 13.2%, 46.1%)',
              fontSize: '14px'
            }}
          >
            <span>
              <i className='bi bi-sign-merge-right'></i>
            </span>
            <span>Merge</span>
          </p>
        </div>
        <div className='right'>
          <p
            onClick={navigateForecastHandler}
            style={{
              border: '1px solid hsl(240, 17.4%, 91%)',
              fontSize: '15px',
              color: 'hsl(240, 46.3%, 8%)',
              fontWeight: '500',
              display: 'flex',
              gap: '5px',
              padding: '5px 7px',
              cursor: 'pointer'
            }}
          >
            <span>
              <i className='bi bi-bar-chart-fill'></i>
            </span>
            <span>{checkStatus || loadingForecast ? <Loader /> : 'Forecast'}</span>
          </p>
          <p
            onClick={navigateHandler}
            style={{
              border: '1px solid hsl(240, 17.4%, 91%)',
              fontSize: '15px',
              color: 'hsl(240, 46.3%, 8%)',
              fontWeight: '500',
              display: 'flex',
              gap: '5px',
              padding: '5px 7px',
              cursor: 'pointer'
            }}
          >
            <span>
              <i className='bi bi-cloud-upload-fill'></i>
            </span>
            <span>{checkStatus || loading ? <Loader /> : 'Back'}</span>
          </p>
          <p
            style={{
              border: '1px solid hsl(240, 17.4%, 91%)',
              fontSize: '15px',
              color: 'hsl(240, 46.3%, 8%)',
              fontWeight: '500',
              display: 'flex',
              gap: '5px',
              padding: '5px 7px'
            }}
          >
            <span>
              <i className='bi bi-filetype-pdf' style={{ color: '#cccccc' }}></i>
            </span>
            <span style={{ color: '#cccccc' }}>Pivot View</span>
          </p>
          <p
            style={{
              border: '1px solid hsl(240, 17.4%, 91%)',
              fontSize: '15px',
              color: 'hsl(240, 46.3%, 8%)',
              fontWeight: '500',
              display: 'flex',
              gap: '5px',
              padding: '5px 7px'
            }}
          >
            <span>
              <i className='bi bi-cloud-arrow-down' style={{ color: '#cccccc' }}></i>
            </span>
            <span style={{ color: '#cccccc' }}>Download</span>
          </p>
        </div>
      </div>
    </>
  )
}

export default TableNavigation
